export default function useGetImage(htmlstr) {
  const reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;
  let arr = [];
  let tem = [];
  while ((tem = reg.exec(htmlstr))) {
    let url = tem[2];
    if (url.indexOf("http") == -1) {
      arr.push("https://zsrbapp.zsnews.cn" + tem[2]);
    } else {
      arr.push(tem[2]);
    }
  }
  return arr;
}
